import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { WebfleetIntegration } from "@/components/vehicles";
import type { VehiclePanelBaseProps } from "../../shared";

export function VehicleIntegrations({ vehicleId }: VehiclePanelBaseProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<ContentCard
			title={t("integrations.integration")}
			icon={icon("Plug")}
		>
			<WebfleetIntegration vehicleId={vehicleId} />
		</ContentCard>
	);
}
